import React, { useContext } from 'react';
import { Upload } from 'antd';
import Papa from 'papaparse';
import uuid from 'uuid';

import { Button } from '../design';
import icUpload from 'utils/assetFiles/svgs/icUpload';
import { PageContext } from '../PageProvider';
import { generatePassword } from '../helper';
import adminRequests from 'services/admin';
import { message } from 'shell/components';

const { Dragger } = Upload;

const UploadCSV = ({ onRequest }) => {
    const { reviewData, setReviewData } = useContext(PageContext);

    const handleRequest = ({ file, onProgress, onSuccess, onError }) => {
        onProgress();

        try {
            const reader = new FileReader();
            reader.onload = async () => {
                const text = reader.result;
                const { data = [] } = Papa.parse(text, { header: true }) || {};

                // Add students into the table
                let csvVerified = true;
                const { students = [], instructors = [] } = reviewData;
                const newStudents = data.map((item) => {
                    const strUsername = String(item.studentId).toLowerCase();
                    const data = {
                        studentId: strUsername,
                        username: strUsername,
                        name: item.name,
                        group: item.group,
                    };

                    // Mark the row as invalid if any field is empty
                    if (!item.studentId || !item.name || !item.group) {
                        csvVerified = false;
                        return { ...data, invalid: true };
                    }
                    return data;
                });

                if (!csvVerified) {
                    message.error('The uploaded CSV contains a field with empty value');
                }

                // Verify if there is any duplicated student IDs
                const unique = new Set();
                const newUsers = [].concat(instructors, students, newStudents);
                const isDuplicate = newUsers.some((item) => {
                    const strUsername = String(item.username).toLowerCase();
                    return unique.size === unique.add(strUsername).size;
                });
                if (isDuplicate) {
                    message.error('The same student IDs appear more than once');
                    onError();
                    return;
                }

                // Retrieve all students with provided usernames and compare if it exists
                // const existingUsers = await postRequest(ADMIN.LIST_USERS, {
                //     usernames: newStudents.map((s) => s.studentId),
                // });
                const existingUsers = await adminRequests.listUsers({
                    usernames: newStudents.map((s) => s.studentId),
                });

                // Accounts are mapped if there is an existing user record
                const verifiedStudents = newStudents.map((item) => {
                    const user = existingUsers.find((u) => u.usernames === item.username);
                    if (user) {
                        return {
                            id: user.id,
                            studentId: user.studentId,
                            username: user.username,
                            name: user.name,
                            group: item.group,
                            record: true,
                            invalid: item.invalid,
                        };
                    }
                    return {
                        id: uuid.v4(),
                        studentId: item.studentId,
                        username: item.username,
                        name: item.name,
                        group: item.group,
                        password: generatePassword(),
                        invalid: item.invalid,
                    };
                });

                setReviewData((prev) => ({
                    ...prev,
                    students: [].concat(prev.students, verifiedStudents),
                }));
                onRequest();
                onSuccess();
            };
            reader.readAsText(file);
        } catch (err) {
            onError();
        }
    };

    return (
        <Dragger accept='.csv' style={{ padding: 10 }} customRequest={handleRequest}>
            {icUpload}
            <p className='ant-upload-text'>Drag and Drop to Upload</p>
            <p>Or</p>
            <div style={{ marginTop: 10 }}>
                <Button>Browse</Button>
            </div>
        </Dragger>
    );
};

export default UploadCSV;
